// Note: This file should replace packages/core/src/i18n.ts
// Note: each feature would register its locale with i18next.addResourceBundle

import i18next from 'i18next';
import backend from 'i18next-http-backend';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import fenrirI18n from '@packages/fenrir/locales/i18n';

i18next
  .use(ICU)
  .use(backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safe from xss
    },
    lng: 'en',
    returnNull: false,
  });

i18next.on('languageChanged', (lng) => {
  fenrirI18n.changeLanguage(lng);
});

export default i18next;
